import {Parameter} from '../../types/model/framework/Parameter';
import {request} from '../request';
import {ExecutionContainer} from '../../types/model/framework/ExecutionContainer';
import {PostProcessorType} from '../../types/postprocessor/PostProcessorType';

export async function getPostProcessorParameters({
  projectId,
  applicationId,
  spaId,
  executionContainer,
  postProcessorType,
}: {
  projectId: string;
  applicationId: string;
  spaId?: string;
  executionContainer?: ExecutionContainer;
  postProcessorType?: PostProcessorType;
}) {
  let url = `/postprocessor/parameters/get/${projectId}/${applicationId}`;
  if (spaId) {
    url += `?spaId=${spaId}`;
  }
  if (executionContainer) {
    url += `&executionContainer=${executionContainer}`;
  }
  if (postProcessorType) {
    url += `&postProcessorType=${postProcessorType}`;
  }
  return request<Array<Parameter>>({
    method: 'get',
    url,
  });
}
